"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _shopList = require("@/api/shop/shopList.js");
var _ShopForm = _interopRequireDefault(require("./components/ShopForm.vue"));
var _BusinessHours = _interopRequireDefault(require("./components/BusinessHours.vue"));
var _BookingTimeConfig = _interopRequireDefault(require("./components/BookingTimeConfig.vue"));
var _BatchSetting = _interopRequireDefault(require("./components/BatchSetting.vue"));
var _BatchSettingLog = _interopRequireDefault(require("./components/BatchSettingLog.vue"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'shopManagement',
  components: {
    ShopForm: _ShopForm.default,
    BusinessHours: _BusinessHours.default,
    BookingTimeConfig: _BookingTimeConfig.default,
    BatchSetting: _BatchSetting.default,
    BatchSettingLog: _BatchSettingLog.default
  },
  data: function data() {
    return {
      // 搜索表单数据
      searchForm: {},
      // 表格数据
      tableData: [],
      regionOptions: [],
      dialogVisible: false,
      tableLoading: true,
      formType: 'add',
      // 表单类型：add-新增，edit-编辑
      currentShop: null,
      // 当前编辑的店铺数据
      activeTab: 'list',
      // 当前激活的标签页
      editTabs: [],
      // 编辑标签页列表
      tabIndex: 0,
      // 标签页索引计数器
      showExportDialog: false,
      // 导出文件选择弹窗
      // 分页数据
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      }
    };
  },
  created: function created() {
    var _this = this;
    this.handleSearch();
    (0, _shopList.getEffectiveCityList)().then(function (res) {
      _this.regionOptions = res.data;
      console.log(_this.formData);
    });
  },
  methods: {
    // ShopList() {
    //   // getshopList(this.searchForm).then(res => {
    //   //   this.tableData = res.records
    //   //   console.log(this.tableData)
    //   // })
    // },
    /**
     * 处理搜索
     * 根据店铺名称和状态过滤表格数据
     */
    handleSearch: function handleSearch() {
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;
      this.tableLoading = true;
      // 添加分页参数
      var params = _objectSpread(_objectSpread({}, this.searchForm), {}, {
        page: this.pagination.page,
        limit: this.pagination.limit
      });
      // 查询门店信息（后端根据searchForm中的status参数进行筛选）
      (0, _shopList.getshopList)(params).then(function (res) {
        _this2.tableData = res.records;
        _this2.pagination.total = res.total || 0;
        _this2.tableLoading = false;
      });
    },
    /**
     * 每页条数变化
     */
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1;
      this.getList();
    },
    /**
     * 当前页变化
     */
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagination.page = val;
      this.getList();
    },
    handleWxDisplay: function handleWxDisplay(value, storeId) {
      var _this3 = this;
      console.log(value, storeId);
      var params = {
        storeId: storeId,
        isStop: value ? 1 : 0
      };
      (0, _shopList.updateStore)(params).then(function () {
        _this3.$message.success('修改成功');
      });
    },
    handleAliDisplay: function handleAliDisplay(value, storeId) {
      var _this4 = this;
      console.log(value, storeId);
      var params = {
        storeId: storeId,
        isStopAli: value ? 1 : 0
      };
      (0, _shopList.updateStore)(params).then(function () {
        _this4.$message.success('修改成功');
      });
    },
    handleFullCoverage: function handleFullCoverage(value, storeId) {
      var _this5 = this;
      console.log(value, storeId);
      var params = {
        storeId: storeId,
        fullCoverage: value ? 1 : 0
      };
      (0, _shopList.updateStore)(params).then(function () {
        _this5.$message.success('修改成功');
      });
    },
    /**
     * 添加门店
     * 创建新的标签页用于添加门店信息
     */
    handleAdd: function handleAdd() {
      var newTabName = "add-".concat(++this.tabIndex);
      this.editTabs.push({
        title: '添加门店',
        name: newTabName,
        type: 'add',
        shopData: null
      });
      this.activeTab = newTabName;
    },
    /**
     * 编辑门店
     * @param {Object} row - 当前行的店铺数据
     */
    handleEdit: function handleEdit(row) {
      var newTabName = "edit-".concat(++this.tabIndex);
      // 确保 area 是数字类型
      if (row.area !== undefined) {
        row.area = Number(row.area);
      }
      // 确保 markers 是数组类型
      if (row.markers !== undefined && typeof row.markers === 'string') {
        try {
          row.markers = JSON.parse(row.markers);
        } catch (e) {
          row.markers = [];
        }
      }
      this.editTabs.push({
        title: "\u7F16\u8F91 - ".concat(row.storeName),
        name: newTabName,
        type: 'edit',
        shopData: _objectSpread({}, row)
      });
      this.activeTab = newTabName;
    },
    /**
     * 处理营业预点设置
     * @param {Object} row - 当前行的店铺数据
     */
    handleBusinessHours: function handleBusinessHours(row) {
      var newTabName = "hours-".concat(++this.tabIndex);
      this.editTabs.push({
        title: "\u8425\u4E1A\u9884\u70B9 - ".concat(row.storeName),
        name: newTabName,
        type: 'businessHours',
        shopData: _objectSpread({}, row)
      });
      this.activeTab = newTabName;
    },
    /**
     * 处理预约时间设置
     * @param {Object} row - 当前行的店铺数据
     */
    handleBookingTime: function handleBookingTime(row) {
      var newTabName = "booking-".concat(++this.tabIndex);
      this.editTabs.push({
        title: "\u9884\u7EA6\u65F6\u95F4 - ".concat(row.storeName),
        name: newTabName,
        type: 'bookingTime',
        shopData: _objectSpread({}, row)
      });
      this.activeTab = newTabName;
    },
    /**
     * 移除标签页
     * @param {string} targetName - 要移除的标签页名称
     */
    removeTab: function removeTab(targetName) {
      var tabs = this.editTabs;
      var activeName = this.activeTab;
      if (activeName === targetName) {
        tabs.forEach(function (tab, index) {
          if (tab.name === targetName) {
            var nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            } else {
              activeName = 'list';
            }
          }
        });
      }
      this.activeTab = activeName;
      this.editTabs = tabs.filter(function (tab) {
        return tab.name !== targetName;
      });
    },
    /**
     * 处理表单提交
     * 图片已预上传为相对路径字符串，直接发送 JSON
     */
    onSubmit: function onSubmit(formData) {
      var _this6 = this;
      var submitData = _objectSpread({}, formData);
      if (!this.activeTab.startsWith('add')) {
        // 编辑时排除二维码字段，不允许通过编辑修改二维码
        delete submitData.rechargeCode;
        delete submitData.preOrderCode;
        delete submitData.selfPickupCode;
        delete submitData.takeAwayCode;
      }
      var isAdd = this.activeTab.startsWith('add');
      (0, _shopList.saveStore)(submitData).then(function () {
        _this6.$message.success(isAdd ? '添加成功' : '编辑成功');
        _this6.getList();
      });
      this.removeTab(this.activeTab);
    },
    /**
     * 处理批量设置
     * 创建新的标签页用于批量设置门店配置
     */
    handleBatchSetting: function handleBatchSetting() {
      var newTabName = "batch-".concat(++this.tabIndex);
      this.editTabs.push({
        title: '批量设置',
        name: newTabName,
        type: 'batchSetting',
        shopData: null
      });
      this.activeTab = newTabName;
    },
    /**
     * 处理批量设置日志
     * 创建新的标签页用于查看批量设置日志
     */
    handleBatchSettingLog: function handleBatchSettingLog() {
      // 检查是否已经打开了日志标签页
      var existingTab = this.editTabs.find(function (tab) {
        return tab.type === 'batchSettingLog';
      });
      if (existingTab) {
        this.activeTab = existingTab.name;
        return;
      }
      var newTabName = "log-".concat(++this.tabIndex);
      this.editTabs.push({
        title: '批量设置日志',
        name: newTabName,
        type: 'batchSettingLog',
        shopData: null
      });
      this.activeTab = newTabName;
    },
    /**
     * 处理批量设置表单提交
     * @param {Object} formData - 批量设置数据
     */
    onBatchSettingSubmit: function onBatchSettingSubmit(formData) {
      // TODO: 处理批量设置数据保存
      console.log('批量设置数据:', formData);
      this.removeTab(this.activeTab);
      this.getList();
    },
    /**
     * 处理营业时间表单提交
     * @param {Object} formData - 营业时间数据
     */
    onBusinessHoursSubmit: function onBusinessHoursSubmit(formData) {
      var _this7 = this;
      // 处理营业时间数据保存
      console.log('营业时间数据:', formData);

      // 构建更新请求数据
      // 注意：后端字段是 is_ws (外卖)，不是 is_wm
      var updateData = {
        storeId: formData.storeId,
        serv_time: formData.serv_time,
        is_ts: String(formData.isTs),
        // 堂食启用状态
        is_zt: String(formData.isZt),
        // 自提启用状态
        is_ws: String(formData.isWm) // 外卖启用状态 (后端使用 is_ws)
      };

      // 调用API更新营业时间
      (0, _shopList.updateBusinessHours)(updateData).then(function () {
        _this7.$message.success('营业时间设置成功');
        _this7.removeTab(_this7.activeTab);
        _this7.getList();
      }).catch(function (error) {
        console.error('营业时间设置失败:', error);
        _this7.$message.error('营业时间设置失败');
      });
    },
    /**
     * 处理预约时间表单提交
     * @param {Object} formData - 预约时间数据
     */
    onBookingTimeSubmit: function onBookingTimeSubmit(formData) {
      var _this8 = this;
      // 处理预约时间数据保存
      console.log('预约时间数据:', formData);

      // 构建更新请求数据
      var updateData = {
        storeId: formData.storeId,
        bookingTimeConfig: formData.bookingTimeConfig
      };

      // 调用API更新预约时间
      (0, _shopList.updateStore)(updateData).then(function () {
        _this8.$message.success('预约时间设置成功');
        _this8.removeTab(_this8.activeTab);
        _this8.getList();
      }).catch(function (error) {
        console.error('预约时间设置失败:', error);
        _this8.$message.error('预约时间设置失败');
      });
    },
    /**
     * 导出报告
     * 导出充值码/预点码/门店信息
     */
    exportRechargeCode: function exportRechargeCode() {
      var _this9 = this;
      this.showExportDialog = false;
      this.$message.success('正在导出充值码...');
      // TODO: 实现导出逻辑
      (0, _shopList.exportRechargeCode)(this.searchForm).then(function () {
        _this9.$message.success('导出成功，请到导出日志下载');
      });
    },
    /**
     * 导出报告
     * 导出充值码/预点码/门店信息
     */
    exportPreCoded: function exportPreCoded() {
      var _this0 = this;
      this.showExportDialog = false;
      this.$message.success('正在导出预点码...');
      // TODO: 实现导出逻辑
      (0, _shopList.exportImagePreCode)(this.searchForm).then(function () {
        _this0.$message.success('导出成功，请到导出日志下载');
      });
    },
    /**
     * 导出门店信息
     */
    exportInfo: function exportInfo() {
      var _this1 = this;
      this.showExportDialog = false;
      this.$message.success('正在导出门店信息...');
      // TODO: 实现导出逻辑
      (0, _shopList.exportStoreInfo)(this.searchForm).then(function () {
        _this1.$message.success('导出成功，请到导出日志下载');
      });
    },
    /**
     * 导出自提码
     */
    exportSelfPickupCode: function exportSelfPickupCode() {
      var _this10 = this;
      this.showExportDialog = false;
      this.$message.success('正在导出自提码...');
      (0, _shopList.exportSelfPickupCode)(this.searchForm).then(function () {
        _this10.$message.success('导出成功，请到导出日志下载');
      });
    },
    /**
     * 导出外卖码
     */
    exportTakeawayCode: function exportTakeawayCode() {
      var _this11 = this;
      this.showExportDialog = false;
      this.$message.success('正在导出外卖码...');
      (0, _shopList.exportTakeawayCode)(this.searchForm).then(function () {
        _this11.$message.success('导出成功，请到导出日志下载');
      });
    },
    /**
     * 同步门店信息
     */
    syncStore: function syncStore() {
      var _this12 = this;
      this.$confirm('确定要同步所有门店信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 调用后端API同步门店
        _this12.tableLoading = true;
        (0, _shopList.syncStore)().then(function () {
          _this12.tableLoading = false;
          _this12.$message.success('门店信息同步完成');
          _this12.getList(); // 重新加载数据
        }).catch(function () {
          _this12.tableLoading = false;
          _this12.$message.error('门店信息同步失败');
        });
      }).catch(function () {
        _this12.$message.info('已取消同步');
      });
    },
    /**
     * 同步座位码
     * 同步门店的座位码信息
     */
    Synchronization: function Synchronization() {
      this.$message.success('正在同步座位码...');
      // TODO: 实现同步逻辑
    }
  },
  mounted: function mounted() {
    // TODO: 初始化时获取店铺列表数据
  }
};